import axios from "axios";
import { env } from "../env";
import { isTokenExpired, BEARER_TOKEN_KEY, RPC_TOKEN_KEY, LEGACY_TOKEN_KEY } from "../utils/token";

const BASE_URL = env.REACT_APP_API_URL || "/api";

export const getBearerToken = () =>
    localStorage.getItem(BEARER_TOKEN_KEY) ||
  sessionStorage.getItem(BEARER_TOKEN_KEY) ||
  localStorage.getItem(LEGACY_TOKEN_KEY) ||
  sessionStorage.getItem(LEGACY_TOKEN_KEY);

export const getRpcToken = () =>
    localStorage.getItem(RPC_TOKEN_KEY) || sessionStorage.getItem(RPC_TOKEN_KEY);

export const clearAuthData = () => {
    localStorage.removeItem(BEARER_TOKEN_KEY);
    sessionStorage.removeItem(BEARER_TOKEN_KEY);
    localStorage.removeItem(RPC_TOKEN_KEY);
    sessionStorage.removeItem(RPC_TOKEN_KEY);
    localStorage.removeItem(LEGACY_TOKEN_KEY);
    sessionStorage.removeItem(LEGACY_TOKEN_KEY);
    localStorage.removeItem("userInfo");
    sessionStorage.removeItem("userInfo");
    localStorage.removeItem("rememberMe");
};


const api = axios.create({
    baseURL: BASE_URL.endsWith("/api") ? BASE_URL : `${BASE_URL}/api`,
    headers: {
        "Content-Type": "application/json",
    },
});

api.interceptors.request.use(
    (config) => {
        const token = getBearerToken();

        if (token) {
            if (isTokenExpired(token, { expireOnError: false })) {
                clearAuthData();
                window.location.href = "/login";
                return Promise.reject(new Error("Session expired. Please sign in again."));
            }
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const { status, config } = error.response;
            const isSignInRoute = config.url?.includes("/signin") || config.url?.includes("/login");

            if (status === 401 && !isSignInRoute) {
                clearAuthData();
                window.location.href = "/login";
            }
        }

        return Promise.reject(error);
    }
);

const toUrlEncoded = (data) => new URLSearchParams(data).toString();

const apiService = {
    get: (url, config = {}) => api.get(url, config),
    post: (url, data, config = {}) => api.post(url, data, config),
    put: (url, data, config = {}) => api.put(url, data, config),
    delete: (url, config = {}) => api.delete(url, config),
    postFormUrlEncoded: (url, data, config = {}) =>
        api.post(url, toUrlEncoded(data), {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            ...config,
        }),
    postFormData: (url, data, config = {}) => {
        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => formData.append(key, value));
        return api.post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
            ...config,
        });
    },
};

export default apiService;
